import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CatalogControls from '../components/Catalog/CatalogControls'
import Product from "../components/Product"
import { useGetProductsQuery } from "../features/backend/backendApiSlice"
import { selectCatalogFilters, selectCatalogSort, catalogFiltersSet } from '../features/catalogFilters/catalogFiltersSlice'
import { useSelector, useDispatch } from 'react-redux'
import { CATALOG_SORT, PRODUCT_ID_GIFT_CERTIFICATE } from '../utils/enums'
import useTitle from "../hooks/useTitle"
import useDescription from "../hooks/useDescription"
import useCanonical from "../hooks/useCanonical"
import NotFound from '../components/NotFound'

const CatalogView = () => {
  const dispatch = useDispatch()

  const { slug } = useParams()

  // TODO this is dirty, refactor
  if (!['coffee', 'coffee-drips', 'coffee-capsules', 'tea', 'matcha', 'notcoffee', 'accessories', 'archive', 'search', 'weeks-choice'].includes(slug)) { // , 'chernaya-pyatnica', 'new-year'
    return <NotFound />
  }

  useCanonical(import.meta.env.VITE_FRONTEND_URL + 'catalog/' + slug)

  let heading;

  if (slug == 'coffee') {
    heading = 'Кофе в зёрнах';
    useTitle('Кофе в зернах купить в интернет-магазине')
    useDescription('Заказывайте зерновой кофе в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'coffee-drips') {
    heading = 'Кофе в дрип-пакетах';
    useTitle('Кофе в дрип-пакетах купить в интернет-магазине')
    useDescription('Заказывайте кофе в дрип-пакетах в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'coffee-capsules') {
    heading = 'Кофе в капсулах';
    useTitle('Кофе в капсулах купить в интернет-магазине')
    useDescription('Заказывайте кофе в капсулах для кофемашины в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'tea') {
    heading = 'Чай Keen Tiger';
    useTitle('Листовой чай купить в интернет-магазине')
    useDescription('Заказывайте чай листовой в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'matcha') {
    heading = 'Матча';
    useTitle('Чай матча купить в интернет-магазине')
    useDescription('Заказывайте матча чай в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'notcoffee') {
    heading = 'Не кофе';
    useTitle('Какао и другая не кофейная продукция в интернет-магазине')
    useDescription('Заказывайте какао и другую не кофейную продукцию в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'accessories') {
    heading = 'Аксессуары';
    useTitle('Аксессуары для кофе и чая купить в интернет-магазине')
    useDescription('Заказывайте воронки и фильтры для кофе, френч-прессы, аэропрессы, питчеры и кофемолки в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'archive') {
    heading = 'Архив';
    useTitle('Архив товаров интернет-магазина')
    useDescription('Архив кофе и чая. Товары не в наличии.')
  }
  if (slug == 'chernaya-pyatnica') {
    heading = 'Черная пятница';
    useTitle('Черная пятница')
    useDescription('Черная пятница')
  }
  if (slug == 'new-year') {
    heading = 'Новый год';
    useTitle('Новый год')
    useDescription('Новый год')
  }
  if (slug == 'weeks-choice') {
    heading = 'Выбор недели';
    useTitle('Кофе и чай со скидками в интернет-магазине')
    useDescription('Товары со скидками в официальном интернет-магазине rockets.coffee. Самовывоз, доставка по Москве и России. Новинки и акции, отзывы наших покупателей. Бонусная система для постоянных клиентов.')
  }
  if (slug == 'search') {
    heading = 'Поиск';
    useTitle('Поиск')
    useDescription('Поиск')
  }

  const { data, isError, isLoading, isSuccess } = useGetProductsQuery()

  const urlParams = new URLSearchParams(window.location.search)
  const q = urlParams.get('q')

  const products = data ? data.filter((product) => {
    let result = product.categories.find(category => category.slug == slug)
    // if this is a search, get products from all categories
    if (slug == 'search') {
      result = true
    }
    if (q) {
      result = result && product.name.toLowerCase().includes(q.toLowerCase())
    }
    return result
  }) : []

  useEffect(() => {
    if (urlParams.has('filters')) {
      let current = urlParams.get('filters').split(',')
      let filters = current.map(filter => {
        const [category, optionId] = filter.split(':')
        return { category: category, optionId: parseInt(optionId) }
      })
      console.log(filters)
      dispatch(catalogFiltersSet(filters))
    }
  }, [data])

  console.log(products)
  const filters = useSelector(selectCatalogFilters)
  const categoryFilters = filters.filter(filter => filter.category === slug)

  const productsFiltered = products.filter((product) => categoryFilters.every(filter => product.attributes.find(attribute => attribute.options.find(option => option.id == filter.optionId)))).filter(product => product.id != PRODUCT_ID_GIFT_CERTIFICATE)

  const sort = useSelector(selectCatalogSort)
  if (sort != null && sort != CATALOG_SORT.DEFAULT) {
    productsFiltered.sort((a, b) => {
      switch (sort.type) {
        case CATALOG_SORT.PRICE_ASC:
          // return a.variations[0].price - b.variations[0].price
          // get the variation with the lowest price
          const priceA = a.variations.reduce((acc, variation) => variation.price < acc ? variation.price : acc, a.variations[0].price)
          const priceB = b.variations.reduce((acc, variation) => variation.price < acc ? variation.price : acc, b.variations[0].price)
          return priceA - priceB
        case CATALOG_SORT.PRICE_DESC:
          // return b.variations[0].price - a.variations[0].price
          // get the variation with the lowest price
          const priceA2 = a.variations.reduce((acc, variation) => variation.price < acc ? variation.price : acc, a.variations[0].price)
          const priceB2 = b.variations.reduce((acc, variation) => variation.price < acc ? variation.price : acc, b.variations[0].price)
          return priceB2 - priceA2
        case CATALOG_SORT.NEWEST:
          return new Date(b.created_at) - new Date(a.created_at)
        case CATALOG_SORT.OLDEST:
          return new Date(a.created_at) - new Date(b.created_at)
      }
    })
  }
  
  if (sort == null || sort?.type == CATALOG_SORT.DEFAULT) {
    productsFiltered.sort((a, b) => a.priority - b.priority)
  }

  return (
    <div className="container">
      <h1 className="catalog-heading">{heading}</h1>
      <CatalogControls category={slug} products={products} />
      <div className="catalog-products-container">
        {isLoading && <div>Каталог загружается...</div>}
        {isError && <div>Произошла ошибка при загрузке каталога</div>}
        {isSuccess && (
          productsFiltered.length == 0
            ? <div>По выбранным параметрам ничего не найдено, измените фильтры и попробуйте еще раз</div>
            : productsFiltered.map((product) => (
              <Product key={product.id} product={product} />
            ))
          )
        }
      </div>
    </div>
  )
}

export default CatalogView